<script>

export default {
  props: ['item', 'isnew'],
  data() {
    return {

    }
  },
  created() {

  },
  methods: {
  }
}

</script>

<template>
  <div>

    <h5 class="section-header mb-3"><Icon icon="ri:book-2-line"></Icon> Testimonial details</h5>
    <div class="row">
      <div class="col-sm-4">
        <w-field SimpleDataType="String List, Single" v-model="item.status" :Options="[{name: 'Yes', value: '1'}, {name: 'No', value: '0'}]" Title="Live :" Required></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String List, Single" v-model="item.website" :Options="app_website_ids" Title="Website :" required></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String List, Single" v-model="item.featured" :Options="[{name: 'Yes', value: '1'}, {name: 'No', value: '0'}]" Title="Featured :" Required></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="Full name :" v-model="item.posted_by" Required></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String List, Single" v-model="item.stars" :Options="['1', '2', '3', '4', '5']" Title="Stars :" required></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="Posted on :" v-model="item.posted_on" Required></w-field>
      </div>
      <div class="col-sm-12">
        <w-field SimpleDataType="String" Title="Thumbnail :" v-model="item.thumbnail"></w-field>
      </div>
      <div class="col-sm-12">
        <label for="">Content :</label>
        <CkRichEditor v-model="item.content"></CkRichEditor>
      </div>
    </div>
    <div class="clearfix mt-3"></div>

  </div>
</template>
